var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b2b-steps",on:{"click":_vm.goToStep}},[_c('el-steps',{attrs:{"active":_vm.active,"align-center":""}},_vm._l((_vm.steps),function(step,index){return _c('el-step',{key:index,attrs:{"title":step.title}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }